export default "__VITE_ASSET__BHYlyySg__"